import { Header } from '@/@diffrag/layout/Header'
import SideBar from '@/@diffrag/sidebar/SideBar'
import { useSideBarContext } from '@/@diffrag/sidebar/SideBarProvider'
import { cn } from '@/lib/utils'
import { sideBarNavs } from '@/sidebar'
import { Outlet, useLocation } from 'react-router-dom'
import { useUser } from '@/@diffrag/providers/user.provider'
import { filterNavsByRole } from '@/lib/filterNavsByRole'
import type { AdminJwtUser } from '@/constants/adminRole'

const excludeSideBar = ['/plan']

export default function Root() {
  const { isOpen } = useSideBarContext()
  const user = useUser() as AdminJwtUser | undefined
  const navs = filterNavsByRole(sideBarNavs, user)

  const { pathname } = useLocation()

  const hideSideBar = excludeSideBar.some((path) => pathname.startsWith(path))

  return (
    <div
      className="relative h-dvh w-screen text-slate-900 overflow-x-hidden"
      id="main"
    >
      <Header navs={navs} />
      {!hideSideBar && <SideBar navs={navs} />}
      <div
        className={cn('flex flex-col', {
          'md:ml-[72px]': !isOpen,
          'md:ml-[220px] lg:ml-60': isOpen && !hideSideBar,
        })}
      >
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
